import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CLINICIAN_ROLE_LABEL = {
  audiologist: 'Audiologist',
  clinic_owner: 'Owner',
  co_owner: 'Co-Owner',
  technician: 'Technician',
  super_admin: 'Admin',
};

// Audiologist-dropdown source, branch-scoped by the server (active branch / co-owner branches).
export function useClinicians() {
  const [list, setList] = useState([]);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/appointments/clinicians`)
      .then((r) => { if (alive) setList(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return list;
}
